export const apiRoutes = {
    checkLoginStatus: 'api/remote/logged/status',
    sendCustomerLogin: 'api/auth/login',
    verifyOtp: 'api/auth/verify-otp',
    sendOtp: 'api/auth/send-otp',
    setPassword: 'api/auth/set-password',
    sendCustomerRegister: 'api/auth/register',

    // Admin APIs
    adminLogin: 'api/auth/adm/login',
    getExternalApiList: 'api/projects/mc/dashboard',
    getSystemApiLogDetail: 'api/logs/moovetshop/sys/api/get/:id/detail',

    getGraphLogData: 'api/logs/get/graph',
    getExternalApiLogDetail: 'api/logs/get/:id/detail',
    getFilterExternalLogToExport: 'api/logs/get/all/filtered',
    getExternalApiLogsPaginated: 'api/logs/get/all/pagination',
    getSystemApiLogsPaginated: 'api/logs/moovetshop/sys/api/get/all/pagination',
    getNotificationLogsList: 'api/logs/notifications/get/all/pagination',
    getNotificationLogsDetails: 'api/logs/notifications/get/:id/detail',

    portalUsersList: 'api/users/all',
    getRegisteredPortalUserDetail: 'api/users/:id',
    toggleAdminRole: 'api/users/toggle/adm/:userId',
    togglePaymentEnabledStatus: 'api/users/toggle/pmt/:userId',
    toggleWorkDayEnabledStatus: 'api/users/toggle/workday/:userId',
    toggleAccountingRoleStatus: 'api/users/toggle/accounting/:userId',
    togglePosRoleStatus: 'api/users/toggle/pos/:userId',
    fetchUserPrivileges: 'api/users/privilege/:userId',
    updateUserPrivileges: 'api/users/privilege/:userId/assign',
    unblockUser: 'api/users/:id/unblock',
    addCards: 'api/cof',
    getCards: 'api/cof',
    deleteCard: 'api/cof/:cardId',
    getNickNamesForCards: 'api/cof/generate-nicknames',
    runFinalTestForCards: 'api/cof/validate',
    getTestResults: 'api/cof/validate/:testId',
    deleteAccountAndCards: 'api/users/:userId',
    deleteSingleTestResult: 'api/cof/test-result/:singleCardTestId',

    getNVSTestResultsPaginated: 'api/sendnvs/test-results/paginated',
    exportNVSTestResults: 'api/sendnvs/test-results/export',
    deleteNVSTestResult: 'api/sendnvs/test-results/:id',

    // API Credentials Management
    saveNVSAPICredential: 'api/sendnvs/configuration',
    updateNVSAPICredential: 'api/sendnvs/configuration/:id',
    getNVSAPICredentialList: 'api/sendnvs/configuration',
    deleteNVSAPICredential: 'api/sendnvs/configuration/:id',
    getNVSAPICredential: 'api/sendnvs/configuration/:id',
    changeEnableStatusNVSAPICredential: 'api/sendnvs/configuration/enable/:id',

    getEnabledCountryList: 'api/country',

    // Phase2 APIs
    submitTest: 'api/cof/submit-test',
    moneyReceived: 'api/cof/money-received',
    saveEvidenceFiles: 'api/cof/save-evidence-files',
    quitTransaction: 'api/cof/quit-transaction',
};
